Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    formFieldWrapperLabelSmallFontSize: 14,
    formFieldWrapperLabelSmallFontWeight: 400,
    formFieldWrapperLabelSmallLineHeight: "20px",
    formFieldWrapperLabelMediumFontSize: 16,
    formFieldWrapperLabelMediumFontWeight: 400,
    formFieldWrapperLabelMediumLineHeight: "24px",
    formFieldWrapperLabelLargeFontSize: 16,
    formFieldWrapperLabelLargeFontWeight: 400,
    formFieldWrapperLabelLargeLineHeight: "24px",
    formFieldWrapperLabelXlargeFontSize: 16,
    formFieldWrapperLabelXlargeFontWeight: 400,
    formFieldWrapperLabelXlargeLineHeight: "24px",
    formFieldWrapperLabelColorDefault: tokens.themeInkDefault,
    formFieldWrapperLabelColorDisabled: tokens.themeInkDisabled,
    formFieldWrapperLegendSmallFontSize: 14,
    formFieldWrapperLegendSmallFontWeight: 600,
    formFieldWrapperLegendSmallLineHeight: "18px",
    formFieldWrapperLegendMediumFontSize: 16,
    formFieldWrapperLegendMediumFontWeight: 600,
    formFieldWrapperLegendMediumLineHeight: "20px",
    formFieldWrapperLegendLargeFontSize: 16,
    formFieldWrapperLegendLargeFontWeight: 600,
    formFieldWrapperLegendLargeLineHeight: "20px",
    formFieldWrapperLegendXlargeFontSize: 16,
    formFieldWrapperLegendXlargeFontWeight: 600,
    formFieldWrapperLegendXlargeLineHeight: "20px",
    formFieldWrapperLegendColorDefault: tokens.themeInkDefault,
    formFieldWrapperLegendColorDisabled: tokens.themeInkDisabled,
    formFieldWrapperSupportTextFontSize: 14,
    formFieldWrapperSupportTextFontWeight: 400,
    formFieldWrapperSupportTextLineHeight: "20px",
    formFieldWrapperSupportTextColorDefault: tokens.themeInkSubdued,
    formFieldWrapperSupportTextColorDisabled: tokens.themeInkDisabled,
    formFieldWrapperSpacingInsetHorizontalMobile: 2,
    formFieldWrapperSpacingVertical: 2,
    formFieldWrapperLabelFontSizeSmall: 14,
    formFieldWrapperLabelFontSizeDefault: 16,
    formFieldWrapperLabelLineHeightSmall: "20px",
    formFieldWrapperLabelLineHeightDefault: "24px",
    formFieldWrapperLabelFontWeightSmall: 400,
    formFieldWrapperLabelFontWeightDefault: 400,
    formFieldWrapperLegendFontSizeSmall: 14,
    formFieldWrapperLegendFontSizeDefault: 16,
    formFieldWrapperLegendLineHeightSmall: "18px",
    formFieldWrapperLegendLineHeightDefault: "20px",
    formFieldWrapperLegendFontWeight: 600
  }
};